import api from './api';

export interface Video {
  _id: string;
  title: string;
  url: string;
  type: 'youtube' | 'vimeo' | 'mp4' | 'other';
  thumbnail?: string;
  createdAt: string;
}

export interface VideoCreateData {
  title: string;
  url: string;
  type: 'youtube' | 'vimeo' | 'mp4' | 'other';
  thumbnail?: string;
}

export const videoService = {
  // Get all videos for an entity
  getVideos: async (
    workspaceId: string,
    entityType: string,
    entityId: string
  ): Promise<Video[]> => {
    const response = await api.get(
      `/workspaces/${workspaceId}/${entityType}/${entityId}/videos`
    );
    return response.data.videos;
  },

  // Create a new video
  createVideo: async (
    workspaceId: string,
    entityType: string,
    entityId: string,
    data: VideoCreateData
  ): Promise<Video> => {
    const response = await api.post(
      `/workspaces/${workspaceId}/${entityType}/${entityId}/videos`,
      data
    );
    return response.data.video;
  },

  // Update video
  updateVideo: async (
    workspaceId: string,
    videoId: string,
    data: Partial<VideoCreateData>
  ): Promise<Video> => {
    const response = await api.put(
      `/workspaces/${workspaceId}/videos/${videoId}`,
      data
    );
    return response.data.video;
  },

  // Delete video
  deleteVideo: async (workspaceId: string, videoId: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/videos/${videoId}`);
  }
};
